// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";
import {
  getCurrentUser as authGetCurrentUser,
  login as authLogin,
  logout as authLogout,
  LoginParams,
  storeAuthData,
} from "../auth";

/** 获取当前的用户 GET /auth/me */
export async function currentUser(options?: { [key: string]: any }) {
  try {
    const user = await authGetCurrentUser();
    return {
      data: {
        name:
          user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : user.username,
        avatar: user.avatar || undefined,
        userid: user.id,
        email: user.email || undefined,
        signature: user.role,
        title: user.role,
        group: user.role,
        tags: [],
        notifyCount: 0,
        unreadCount: 0,
        country: "VN",
        access: user.role,
        geographic: {
          province: { label: "Hanoi", key: "hanoi" },
          city: { label: "Hanoi", key: "hanoi" },
        },
        address: "",
        phone: user.phone || undefined,
      } as API.CurrentUser,
    };
  } catch (error) {
    console.error("Failed to get current user:", error);
    throw error;
  }
}

/** API đăng xuất */
export async function outLogin(options?: { [key: string]: any }) {
  try {
    authLogout();
    return { success: true };
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
}

/** 登录接口 POST /auth/login */
export async function login(
  body: LoginParams,
  options?: { [key: string]: any }
) {
  try {
    const result = await authLogin(body);
    // Store authentication data
    storeAuthData(result);

    return {
      status: "ok",
      type: "account",
      currentAuthority: result.user.role,
    } as API.LoginResult;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>("/api/notices", {
    method: "GET",
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.RuleList>("/api/rule", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "update",
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "post",
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>("/api/rule", {
    method: "POST",
    data: {
      method: "delete",
      ...(options || {}),
    },
  });
}
